import { ConfigService } from "../ConfigService/config.service"
import { ConfigDelgate } from "../ConfigService/config.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';
import { AuthenticationService } from '../AuthenticationService/authentication.service';

export class ConfigServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService,
        authenticationService?: AuthenticationService
    ): ConfigService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new ConfigDelgate(httpProvider);

        return new ConfigService(delegate, authenticationService);
    }
}